import { RpcImpl } from '../rpc/impls/rpc';
import { DefineRpcMethods, Rpc } from '../rpc/rpc';

export const SmartFilterProxy = Symbol('SmartFilterProxy');

export interface SmartFilterResult {
    /** 过滤结果的 id, 用于标识过滤结果, 唯一标识 */
    filterId: string;
    /** 消息 id 用于和 agent 消息关联 */
    taskId: string;

    /** 用户输入的文本 */
    userInputText: string;

    /** 结果标题 */
    resultTitle: string;

    /** 结果摘要 */
    resultSummary: string;

    /** agent 合并后，表示选中的专利列表 */
    patents: {
        pn: string;
        /**
         * @deprecated agent 合并后不需要了
         */
        patentId?: string;
        /**
         * @deprecated agent 合并后不需要了
         */
        filterItem?: string[];
        /**
         * @deprecated agent 合并后不需要了
         */
        filterReason?: string;
    }[];

    /** 选中的类型 */
    selected?: {
        type: string;
        count?: number;
    }[];

    /**
     * 选中的专利 PN
     * @deprecated agent 合并后不需要了
     */
    selectedPatentPNs?: string[];
}

// 定义 Host 端 RPC 方法
type RpcSmartFilterHost = DefineRpcMethods<{
    /**
    * 追加过滤项
    */
    appendSmartFilterResult(filter: SmartFilterResult): Promise<void>;
}>;

// 定义 Hiro 端 RPC 方法
type RpcSmartFilterHiro = DefineRpcMethods<{
    openSmartFilterResult(params: {
        agentJobId: string;
    }): void
}>;

export interface SmartFilterProxy {
    // eventProxy: EventEmitter<SmartFilterEvents>;
    rpcHost: Rpc<RpcSmartFilterHost>;
    rpcHiro: Rpc<RpcSmartFilterHiro>;
}

export function createSmartFilterProxy(): SmartFilterProxy {
    return {
        // eventProxy: new EventEmitterImpl<SmartFilterEvents>(),
        rpcHost: new RpcImpl<RpcSmartFilterHost>(),
        rpcHiro: new RpcImpl<RpcSmartFilterHiro>(),
    };
}
